import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';

import Typography from '@material-ui/core/Typography';

import {
  DEFAULT_LANGUAGE,
  AVAILABLE_LANGUAGES
} from 'pages/create-activity/constants';

import { FormActionButtons, Input, MultipleSelectField } from 'components';
import { TRANSLATIONS } from 'translations/index';

import validate from './validateSecondLanguage';

import { useStyles } from './styles';

const GeneralCreateSecondLanguage = ({
  save,
  onSubmit,
  handleSubmit,
  setSubmitButton,
  isUpdate,
  ...otherProps
}) => {
  const {
    languages,
    selectedLanguage,
    addLanguage,
    deleteLanguage,
    selectLanguage
  } = otherProps;
  const [t] = useTranslation();

  const classes = useStyles();
  const availableLanguages = [...AVAILABLE_LANGUAGES].filter(
    x => !languages.includes(x)
  );

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('General')}
      </Typography>
      <MultipleSelectField
        availableItems={availableLanguages}
        notAvailableToDeleteItems={[DEFAULT_LANGUAGE]}
        list={languages}
        selectedItem={selectedLanguage}
        addItem={addLanguage}
        deleteItem={deleteLanguage}
        selectItem={selectLanguage}
      />
      <form onSubmit={handleSubmit}>
        <Field
          name={`title`}
          inputProps={{ maxLength: 255 }}
          label={`${TRANSLATIONS[selectedLanguage].title} *`}
          placeholder={`${TRANSLATIONS[selectedLanguage].title}`}
          className={classes.inputIndent}
          component={Input}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

export default reduxForm({
  form: `generalForm`,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate
})(GeneralCreateSecondLanguage);
